import { registerRoute } from '../infra/router/routeRegistry'
import FileExplorerPage from './FileExplorerPage'
import React from 'react'

registerRoute({
  path: '/',
  viewFactory: () => React.createElement(FileExplorerPage)
})